import React, {
  useEffect,
  useState,
} from "react";

function SearchBar({
  search,
  setSearch,
  placeholder = "Search...",
}) {

  const [inputValue, setInputValue] =
    useState(search);

  useEffect(() => {

    const timer = setTimeout(() => {

      setSearch(inputValue);

    }, 500);

    return () => clearTimeout(timer);

  }, [inputValue]);

  return (

    <div className="search-bar">

      <input
        type="text"
        value={inputValue}
        placeholder={placeholder}
        onChange={(e) =>
          setInputValue(e.target.value)
        }
        className="form-control"
      />

    </div>
  );
}

export default SearchBar;